// import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
// import { Modal, Container, Row, Col, Table, Button } from "react-bootstrap";
// import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
// import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions";
// import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal";
// import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik";
// import MasterService from "../../Services/MasterService"; import { IoIosReturnLeft } from "react-icons/io"; import Select from 'react-select';
// import { IoReturnDownBack, IoReturnDownForward } from "react-icons/io5"; import { FaRegFile, FaUserCheck, FaRegSave } from "react-icons/fa";

// export default function IndicatorMappingAcceptanceEntry() {
//   const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
//   const [distlist, setDistlist] = useState();
//   const [searchMandals, setSearchMandals] = useState("");
//   const [maintablenb, setMaintablenb] = useState(true);
//   const [selecteddist, setSelecteddist] = useState(""); const [selecteddistId, setSelecteddistId] = useState(""); const [selectedmandal, setselectedmandal] = useState("");
//   const [remarksStatus, setRemarksStatus] = useState({}); const [criteriaData, setCriteriaData] = useState([]); const [remarksData, setRemarksData] = useState([]);
//   const [remarksText, setRemarksText] = useState({}); const [mandalSummary, setMandalSummary] = useState([]); const [selectedMandalId, setSelectedMandalId] = useState(null); const [allAcceptance, setAllAcceptance] = useState("");
//   const [statusCode, setStatusCode] = useState(""); const [statusId, setStatusId] = useState(null); const [mandalList, setMandalList] = useState([]); const [formikMandalId, setFormikMandalId] = useState("");

//   let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); let username = localStorage.getItem("username");
//   let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid"); let roleid = localStorage.getItem("catid"); let mainroleid = localStorage.getItem("role");
//   let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbid" : "mandalid"); const [showDetailTable, setShowDetailTable] = useState(["111", "117"].includes(roleid));

//   const formik = useFormik({
//     initialValues: { department_id: "", district_id: "", year: "", month: "", },
//   });



//   const MandalListTable = (payload) => {
//     KpiService.getCriteriaSelectionListData(payload).then((res) => {
//       if (res.data && res.data.dataList) { const list = res.data.dataList; setMandalSummary(list); }
//     });
//   }

//   useEffect(() => {
//     let params = { userId: username }
//     let payload = { "userId": username, "districtId": district.toString(), "mandalId": mandalid.toString() }
//     let payload1 = { "userId": username, "districtId": roleid === "115" ? "0" : district.toString(), "mandalId": "0", level: "Mandal" }
//     if (roleid === "117" || roleid === "111") { fetchCriteriaAndRemarks(payload); }
//     if (["113", "119", "115"].includes(roleid)) { MandalListTable(payload1); }
//     MasterService.getDistricts().then((res17) => {
//       if (res17.data) {
//         setDistlist([{ id: "0", value: "All" }, ...(res17.data ?? [])]);
//       }
//     });
//     if (["113", "119", "117", "111"].includes(roleid)) { setSelecteddist(localStorage.getItem("districtname"), setSelecteddistId(district)) }
//     if (["117", "111"].includes(roleid)) { setselectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbname" : "mandalname")) }
//     if (["111", "113", "114", "115"].includes(roleid)) { formik.setFieldValue("department_id", deptId); }
//     if (["113", "114", "111", "115"].includes(roleid)) { formik.setFieldValue("department_id", deptId); formik.setFieldValue("district_id", district); }
//     if (["119", "117"].includes(roleid)) { formik.setFieldValue("district_id", district); }
//   }, []);


//   const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white", wordBreak: "break-word" };





//   const mapRemarksToState = (criteriaList, remarksList) => {
//     const statusObj = {};
//     const remarksObj = {};

//     criteriaList?.forEach((item, index) => {
//       // ✅ match remarks
//       const matched = remarksList.find(
//         (r) => String(r.cs_indicator_id) === String(item.cs_indicator_id)
//       );

//       // ✅ set acceptance FROM criteria API
//       if (item.is_required === true) {
//         statusObj[index] = "yes";
//       } else if (item.is_required === false) {
//         statusObj[index] = "no";
//       }

//       // ✅ set remarks FROM remarks API
//       remarksObj[index] = matched?.remarks || "";
//     });
//     setRemarksStatus(statusObj);
//     setRemarksText(remarksObj);
//   };

//   // const fetchCriteriaAndRemarks = (payload) => {

//   //   Promise.all([
//   //     KpiService.getCriteriaSelectionData({ ...payload, level: "Mandal", }),
//   //     KpiService.getCriteriaSelectionRemarks({ ...payload, level: "Mandal", }),
//   //   ]).then(([criteriaRes, remarksRes]) => {
//   //     const criteriaList = criteriaRes.data?.dataList || [];
//   //     const remarksList = remarksRes.data?.dataList || [];
//   //     setCriteriaData(criteriaList);
//   //     setRemarksData(remarksList);
//   //     if (criteriaList.length > 0) {
//   //       setStatusCode(criteriaList[0].status_code || "");
//   //       setStatusId(criteriaList[0].status_id || null)
//   //     }

//   //     mapRemarksToState(criteriaList, remarksList);
//   //   })
//   //     .catch(() => {
//   //       showAlertMessage("Failed to load data", "error");
//   //     });
//   // };

//   const fetchCriteriaAndRemarks = (payload) => {
//     KpiService.getCriteriaSelectionData({ ...payload, level: "Mandal" })
//       .then((criteriaRes) => {
//         const scode = criteriaRes.data?.SCODE;
//         if (scode === "01") {
//           const criteriaList = criteriaRes.data?.dataList || [];
//           setCriteriaData(criteriaList);
//           if (criteriaList.length > 0) {
//             setStatusCode(criteriaList[0].status_code || "");
//             setStatusId(criteriaList[0].status_id || null);
//           }

//           // 👉 Call second API only if SCODE = "01"
//           return KpiService.getCriteriaSelectionRemarks({
//             ...payload,
//             level: "Mandal",
//           }).then((remarksRes) => {
//             const remarksList = remarksRes.data?.dataList || [];
//             setRemarksData(remarksList);

//             mapRemarksToState(criteriaList, remarksList);
//           });
//         } else {
//           showAlertMessage("Failed to load criteria data", "error");
//         }
//       })
//       .catch(() => {
//         showAlertMessage("Failed to load data", "error");
//       });
//   };

//   const handleAcceptanceChange = (index, value) => {
//     const current = remarksStatus[index];

//     const updated = { ...remarksStatus, [index]: current === value ? undefined : value, };
//     setRemarksStatus(updated);
//     const economicItems = criteriaData.filter((item) => item.cs_indicator_type === "Economic");
//     const allYes = economicItems.every((_, i) => updated[i] === "yes");
//     const allNo = economicItems.every((_, i) => updated[i] === "no");

//     if (allYes) setAllAcceptance("yes");
//     else if (allNo) setAllAcceptance("no");
//     else setAllAcceptance("");
//   };
//   const validateBeforeForward = () => {
//     for (let i = 0; i < criteriaData.length; i++) {
//       const item = criteriaData[i];
//       if (item.cs_indicator_type === "Economic") {
//         const status = remarksStatus[i];
//         if (!status) {
//           showAlertMessage(`Please select Required/Not Required for "${item.cs_indicator_name}"`, "error");
//           return false;
//         }
//         if (status === "no" && !remarksText[i]) { showAlertMessage(`Please enter remarks for "${item.cs_indicator_name}"`, "error"); return false; }
//       }
//     }

//     return true;
//   };

//   const buildPayload = () => {
//     return {
//       userId: username, districtId: (mainroleid === "5" || mainroleid === "62") ? selecteddistId : district, mandalId: mainroleid === "3" ? mandalid : selectedMandalId, level: "Mandal",
//       indicators: criteriaData.map((item, index) => ({
//         csIndicatorId: item.cs_indicator_id,
//         isRequired:
//           item.cs_indicator_type === "Economic" ? remarksStatus[index] === "yes" ? true : remarksStatus[index] === "no" ? false : null : true,
//         remarks: remarksStatus[index] === "no" ? remarksText[index] || null : null,
//       })),
//     };
//   };

//   const handleSave = () => {
//     const payload = buildPayload();
//     payload.type = "save";

//     KpiService.getCriteriaSelectionSave(payload)
//       .then((res) => {
//         const code = res.data?.SCODE
//         const desc = res.data?.SDESC

//         if (code === "01") {
//           showAlertMessage(desc || "Data Saved Successfully", "success", () => {
//             let payload = { "userId": username, "districtId": (mainroleid === "5" || mainroleid === "62") ? selecteddistId.toString() : district.toString(), "mandalId": mainroleid === "3" ? mandalid.toString() : selectedMandalId.toString() }
//             fetchCriteriaAndRemarks(payload);
//           })
//         } else {
//           showAlertMessage(desc || "Save failed", "error");
//         }
//       }).catch(() => {
//         showAlertMessage("Something went wrong", "error");
//       });
//   };


//   const handleForward = () => {
//     if (!validateBeforeForward()) return;

//     const payload = buildPayload();
//     if (mainroleid === "3") {
//       payload.type = "forward"
//     } else if (mainroleid === "2") {
//       payload.type = "approval"
//     }


//     console.log("Forward Payload:", payload);

//     KpiService.getCriteriaSelectionSave(payload)
//       .then((res) => {
//         const code = res.data?.SCODE
//         const desc = res.data?.SDESC
//         if (code === "01") {
//           showAlertMessage(desc || "Data Forwarded Successfully", "success", () => {
//             let payload = { "userId": username, "districtId": district.toString(), "mandalId": mainroleid === "3" ? mandalid.toString() : selectedMandalId.toString() }
//             fetchCriteriaAndRemarks(payload);
//           })

//         } else {
//           showAlertMessage(res.data?.SDESC || "Failed to forward", "error");
//         }
//       })
//       .catch(() => {
//         showAlertMessage("Something went wrong", "error");
//       });

//   };


//   const handleAllAcceptance = (value) => {
//     const updatedStatus = {};

//     criteriaData.forEach((item, index) => {
//       if (item.cs_indicator_type === "Economic") {
//         updatedStatus[index] = value;
//       }
//     });

//     setRemarksStatus(updatedStatus);
//     setAllAcceptance(value);
//   };

//   const handleMandalClick = (mandal) => {
//     setSearchMandals("")
//     setSelectedMandalId(mandal.mandal_id); setselectedmandal(mandal.mandal_name);
//     setSelecteddistId(mandal.district_id);
//     const payload = { userId: username, districtId: mandal.district_id, mandalId: mandal.mandal_id, };
//     fetchCriteriaAndRemarks(payload);
//     setShowDetailTable(true);
//   };

//   const handleBack = () => {
//     if (!validateBeforeForward()) return;
//     const payload = buildPayload();
//     payload.type = "returntoaso";
//     KpiService.getCriteriaSelectionSave(payload)
//       .then((res) => {
//         const code = res.data?.SCODE
//         const desc = res.data?.SDESC
//         if (code === "01") {
//           showAlertMessage(desc || "Data Saved Successfully", "success", () => {
//             let payload = { "userId": username, "districtId": selecteddistId, "mandalId": mainroleid === "3" ? mandalid.toString() : selectedMandalId.toString() }
//             fetchCriteriaAndRemarks(payload);
//           })
//         } else {
//           showAlertMessage(desc || "Save failed", "error");
//         }
//       }).catch(() => {
//         showAlertMessage("Something went wrong", "error");
//       });
//   }
//   const MandalData = (id) => {
//     setSearchMandals(""); formik.setFieldValue("mandal_id", ""); setselectedmandal(""); setFormikMandalId(""); setShowDetailTable(false); setMandalSummary([]); setCriteriaData([]);
//     if (!id) {
//       setSelecteddistId(""); setMandalList([]); formik.setFieldValue("district_id", "");
//       return;
//     }

//     setSelecteddistId(id);

//     let params = { district_id: id };
//     MasterService.getMandals(params).then((res) => {
//       if (res.data) {
//         setMandalList([{ id: "0", value: "All" }, ...(res.data ?? [])]);
//       }
//       else { setMandalList([]) }

//     })
//   }

//   const Planning = (mandalid) => {
//     setSearchMandals("");
//     if (!mandalid) {
//       formik.setFieldValue("mandal_id", ""); setselectedmandal(""); setFormikMandalId(""); setShowDetailTable(false); setMandalSummary([]); setCriteriaData([]);
//       return;
//     }
//     setFormikMandalId(mandalid);
//     let payload = { "userId": username, "districtId": selecteddistId, "mandalId": mandalid, level: "Mandal" }
//     MandalListTable(payload)

//   }


//   const filteredMandalsData =
//     searchMandals.length > 0 ? mandalSummary?.filter((item) => {
//       return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchMandals.toLowerCase())); })
//       );
//     }) : mandalSummary;

//   return (
//     <>
//       <Menubar />
//       <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>Mandal Performance Indicators Mapping
//         <span> Acceptance Entry </span> </h2> </div> </Container>

//       <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
//         <FormikProvider value={formik}>
//           <Form onSubmit={formik.handleSubmit}>
//             <div className="mb-3">
//               <Row>
//                 {["113", "119", "117", "111", "116"].includes(roleid) &&
//                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label>
//                     <Select
//                       {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: (mainroleid === "5" || mainroleid === "62") ? false : true, extraOnChange: (option) => { MandalData(option?.id || null) } })}
//                     /> </Col>}

//                 {["117", "111"].includes(roleid) &&
//                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
//                     <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111" ? deptId : formik.values.department_id) ? "ULB" : "Mandal"}</label>
//                     <Field className="mb-3 form-control" name="mandal_id" type="text" value={selectedmandal} controlId="formBasicEmail"
//                       disabled={true} style={{ fontWeight: "bold" }} /> </Col>}

//                 {["5", "62"].includes(mainroleid) &&
//                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
//                     <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111" ? deptId : formik.values.department_id) ? "ULB" : "Mandal"}</label>
//                     <Select className="w-100" isClearable={true} isSearchable={true} name="mandal_id" required={true} getOptionValue={(option) => option.id} getOptionLabel={(option) => option?.value} options={mandalList} value={mandalList?.find((option) => option.id === formik.values?.mandal_id) || null} onChange={(option) => { Planning(option?.id); formik.setFieldValue("mandal_id", option ? option.id : ""); }}
//                       menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), }}
//                     />
//                   </Col>}

//               </Row> </div> </Form> </FormikProvider>


//         {/* ================= SUMMARY TABLE (113,119) ================= */}
//         {["113", "119", "115", "116"].includes(roleid) && !showDetailTable && (<>
//           <Row>
//             <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-1" >
//               <div class="input-group">
//                 <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
//                 <input type="text" className="form-control" value={searchMandals} placeholder="Search" onChange={(event) => setSearchMandals(event.target.value)} />
//               </div>
//             </Col>
//           </Row>
//           <div id="table-scroll" className="table-scroll"> <div className="table-wrap">

//             <Table bordered className="custom-table">
//               <thead>
//                 <tr className="text-center"> <th>Sl.No</th>
//                   {formik.values.district_id === "0" &&
//                     <th>District</th>}
//                   <th>{roleid === "115" ? "District" : "Mandal"}</th>
//                   <th>Total Indicators</th> <th>Required</th> <th>Not Required</th> <th>Status</th> </tr>

//               </thead>

//               <tbody>
//                 {filteredMandalsData?.map((item, index) => (
//                   <tr key={index}>
//                     <td className="text-center">{index + 1}</td>
//                     {formik.values.district_id === "0" && <td>{item?.district_name}</td>}
//                     <td className="text-left">{roleid === "115" ? item.district_name : item.mandal_name} </td> <td className="text-center">{item.total_indicators}</td> <td className="text-center">{item.required_indicators}</td> <td className="text-center">{item.remaining_indicators}</td> <td className="text-center">
//                       {item.status_code !== null ? (
//                         <button type="button" onClick={() => handleMandalClick(item)} style={{ color: "darkblue", cursor: "pointer", textDecoration: "underline", background: "none", border: "none", padding: 0, }} >
//                           {item.status_code}
//                         </button>
//                       ) : (
//                         "-"
//                       )}
//                     </td>

//                   </tr>))}
//               </tbody>
//             </Table>
//           </div>
//           </div>
//         </>)}

//         {showDetailTable && maintablenb && <>

//           <Row>
//             {["113", "119", "116"].includes(roleid) && (
//               <Col xs="auto" className="ms-auto">
//                 <Button
//                   variant="warning"
//                   size="sm"
//                   className="btn  mb-2 warn-btn"
//                   onClick={() => {
//                     MandalListTable({ userId: username, districtId: (mainroleid === "5" || mainroleid === "62") ? formik.values.district_id : district, mandalId: (mainroleid === "5" || mainroleid === "62") ? formikMandalId : mandalid, level: "Mandal" })
//                     setShowDetailTable(false)
//                   }}
//                 >
//                   <IoIosReturnLeft style={{ fontSize: "20px" }} /> Back
//                 </Button>

//               </Col>)}
//           </Row>
//           <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
//             <span className="style">  Mandal Performance Indicators Mapping</span>
//             {selectedmandal && (<div style={{ fontWeight: "bold", marginTop: "5px" }}> Mandal: {selectedmandal} </div>)}
//             {statusCode && ["111", "117"].includes(roleid) && (<div style={{ marginTop: "5px", color: "#2f4f4f", fontWeight: "500" }}> Status: {statusCode} </div>
//             )}

//           </div>

//           <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
//             <Table bordered id="my-table" className="custom-table table table-bordered sticky-table">

//               <thead>
//                 <tr className="text-center">
//                   <th style={{ headerStyle, width: "100px" }} rowSpan={2}>Sl.No.</th>
//                   <th style={{ headerStyle, width: "200px" }} rowSpan={2}>Indicator Type</th>
//                   <th style={{ ...headerStyle, width: "200px" }} rowSpan={2}> Indicator </th>
//                   <th style={{ headerStyle, width: "300px" }} >Acceptance</th>

//                   <th style={headerStyle} rowSpan={2}>Remarks</th>
//                 </tr>

//                 <tr className="text-center">
//                   <th>
//                     <label className="me-3 text-white">
//                       <input
//                         type="radio"
//                         name="allAcceptance"
//                         value="yes"
//                         checked={allAcceptance === "yes"}
//                         onChange={() => handleAllAcceptance("yes")}
//                         disabled={(mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4)}

//                       />{" "}
//                       All Required
//                     </label>

//                     <label className="text-white">
//                       <input
//                         type="radio"
//                         name="allAcceptance"
//                         value="no"
//                         checked={allAcceptance === "no"}
//                         disabled={(mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4)}
//                         onChange={() => handleAllAcceptance("no")}
//                       />{" "}
//                       All Not Required
//                     </label>
//                   </th>
//                 </tr>
//               </thead>



//               <tbody>

//                 {criteriaData?.map((item, index) => (
//                   <tr key={index}>
//                     <td className="text-center">{index + 1}</td>
//                     <td style={{ textAlign: "left" }}>
//                       {item.cs_indicator_type}
//                     </td>

//                     <td style={{ textAlign: "left", width: "350px", maxWidth: "350px", whiteSpace: "normal", wordBreak: "break-word", }} >
//                       {item.cs_indicator_name}
//                     </td>

//                     <td className="text-center">
//                       <label className="me-3">
//                         <input
//                           type="radio"
//                           name={`acceptance_${index}`}
//                           value="yes"
//                           checked={item.cs_indicator_type !== "Economic" ? true : remarksStatus[index] === "yes"}
//                           disabled={(item.cs_indicator_type !== "Economic") || ((mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4))}
//                           required={item.is_required}
//                           onChange={() => handleAcceptanceChange(index, "yes")}
//                         />{" "}
//                         Required
//                       </label>

//                       <label>
//                         <input
//                           type="radio"
//                           name={`acceptance_${index}`}
//                           value="no"
//                           disabled={(item.cs_indicator_type !== "Economic") || ((mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4))}
//                           checked={remarksStatus[index] === "no"}
//                           onChange={() => handleAcceptanceChange(index, "no")}
//                         />{" "}
//                         Not Required
//                       </label>
//                     </td>

//                     <td>
//                       {remarksStatus[index] === "no" && item.cs_indicator_type === "Economic" && (
//                         <textarea
//                           id={`remarks_${index}`}
//                           className="form-control"
//                           placeholder="Enter remarks"
//                           rows={2}
//                           title={remarksText[index] || ""}
//                           value={remarksText[index] || ""}
//                           onChange={(e) =>
//                             setRemarksText({
//                               ...remarksText,
//                               [index]: e.target.value,
//                             })

//                           }
//                           disabled={(mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4)}

//                         />
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>

//             </Table>

//           </div> </div> </>}

//         {((mainroleid === "3" && statusId === 1) || (mainroleid === "2" && statusId === 2)) && showDetailTable && (

//           <Row className="mt-3">
//             <Col className="text-center">
//               <div className="bottom-buttons d-flex justify-content-center mb-5">
//                 <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button> <Button variant="" size="sm" className="next-btn me-4" onClick={handleForward} > {mainroleid === "2" ? "Approve" : "Forward"}<IoReturnDownForward style={{ fontSize: "18px", marginLeft: "5px" }} /> </Button></div> </Col>
//           </Row>)}

//         {((mainroleid === "5" || mainroleid === "62") && statusId === 4) && showDetailTable && (

//           <Row className="mt-3">
//             <Col className="text-center">
//               <div className="bottom-buttons d-flex justify-content-center mb-5">
//                 <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button>
//                 <Button variant="" size="sm" className="next-btn me-4" onClick={handleBack} >Sent Back to ASO<IoReturnDownBack style={{ fontSize: "18px", marginLeft: "5px" }} /> </Button></div> </Col>
//           </Row>)}

//       </Container>

//       <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
//     </>
//   );
// }


import React, { useEffect, useState } from "react"; import Menubar from "../Menubar";
import {  Container, Row, Col, Table, Button } from "react-bootstrap";
import {  AiOutlineSearch } from "react-icons/ai";
import { commonSelectProps } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik";
import MasterService from "../../Services/MasterService"; import { IoIosReturnLeft } from "react-icons/io"; import Select from 'react-select';
import { IoReturnDownForward } from "react-icons/io5"; import { FaRegSave } from "react-icons/fa";

export default function IndicatorMappingAcceptanceEntry() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [distlist, setDistlist] = useState();const[yearsList,setYearsList]=useState([]);
  const [searchMandals, setSearchMandals] = useState("");const[planningCheckBox,setPlanningCheckBox]=useState({});
  const [maintablenb, setMaintablenb] = useState(true);const [planningremarksText, setPlanningremarksText] = useState({});
  const [selecteddist, setSelecteddist] = useState(""); const [selecteddistId, setSelecteddistId] = useState(""); const [selectedmandal, setSelectedmandal] = useState("");
  const [remarksStatus, setRemarksStatus] = useState({}); const [criteriaData, setCriteriaData] = useState([]); const [remarksData, setRemarksData] = useState([]);
  const [remarksText, setRemarksText] = useState({}); const [mandalSummary, setMandalSummary] = useState([]); const [selectedMandalId, setSelectedMandalId] = useState(null); const [allAcceptance, setAllAcceptance] = useState("");
  const [statusCode, setStatusCode] = useState(""); const [statusId, setStatusId] = useState(null); const [mandalList, setMandalList] = useState([]); const [formikMandalId, setFormikMandalId] = useState("");

  let ulbdeptlist = JSON.parse(localStorage.getItem("ulbdeptlist") || "[]"); let username = localStorage.getItem("username");
  let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid"); let roleid = localStorage.getItem("catid"); let mainroleid = localStorage.getItem("role");
  let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbid" : "mandalid"); const [showDetailTable, setShowDetailTable] = useState(["111", "117"].includes(roleid));

  const formik = useFormik({
    initialValues: { department_id: "", district_id: "", year: "", month: "", },
  });



  const MandalListTable = (payload) => {
    setShowDetailTable(false);
    setPlanningCheckBox({});
    KpiService.getCriteriaSelectionListData(payload).then((res) => {
      if (res.data?.dataList) { const list = res.data.dataList; setMandalSummary(list); }
    });
  }

  useEffect(() => {
   
    MasterService.getDistricts().then((res17) => {
      if (res17.data) {
        setDistlist([{ id: "0", value: "All" }, ...(res17.data ?? [])]);
      }
    });
     MasterService.getindicatorAcceptanceYear().then((res) => {
      if (res.data) {
        setYearsList(res.data );
      }
    });
    if (["113", "119", "117", "111"].includes(roleid)) { setSelecteddist(localStorage.getItem("districtname"), setSelecteddistId(district)) }
    if (["117", "111"].includes(roleid)) { setSelectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId) ? "ulbname" : "mandalname")) }
    if (["111", "113", "114", "115"].includes(roleid)) { formik.setFieldValue("department_id", deptId); }
    if (["113", "114", "111", "115"].includes(roleid)) { formik.setFieldValue("department_id", deptId); formik.setFieldValue("district_id", district); }
    if (["119", "117"].includes(roleid)) { formik.setFieldValue("district_id", district); }
  }, []);


  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white", wordBreak: "break-word" };




const mapRemarksToState = (criteriaList, remarksList) => {
  const statusObj = {};
  const remarksObj = {};
  const remarksObjplanning = {};

  criteriaList.forEach((item, index) => {
    // ✅ match remarks
    const matched = remarksList.find(
      (r) => String(r.cs_indicator_id) === String(item.cs_indicator_id)
    );

    // ✅ set acceptance FROM criteria API
    if (item.is_required === true) {
      statusObj[index] = "yes";
    } else if (item.is_required === false) {
      statusObj[index] = "no";
    }

    // ✅ set remarks FROM remarks API
    remarksObj[index] = matched?.remarks || "";
    remarksObjplanning[index] = matched?.planning_remarks || "";
  });
  setRemarksStatus(statusObj);
  setRemarksText(remarksObj);
  setPlanningremarksText(remarksObjplanning);
};




  const fetchCriteriaAndRemarks = (payload) => {
  setCriteriaData([]);
  setRemarksData([]);

  setPlanningCheckBox({});

  KpiService.getCriteriaSelectionData({ ...payload, level: "Mandal" })
    .then((criteriaRes) => {
      const scode = criteriaRes.data?.SCODE;

      if (scode === "01") {
        const criteriaList = criteriaRes.data?.dataList || [];
        setCriteriaData(criteriaList);

        if (criteriaList.length > 0) {
          setStatusCode(criteriaList[0].status_code || "");
          setStatusId(criteriaList[0].status_id || null);
        }

        return KpiService.getCriteriaSelectionRemarks({
          ...payload,
          level: "Mandal",
        }).then((remarksRes) => {
          const remarksList = remarksRes.data?.dataList || [];
          setRemarksData(remarksList);

          mapRemarksToState(criteriaList, remarksList);
        });
      } else {
        // 👉 CLEAR if no data
        setCriteriaData([]);
        setRemarksData([]);
        showAlertMessage("No Data Found", "error");
      }
    })
    .catch(() => {
      // 👉 CLEAR on error also
      setCriteriaData([]);
      setRemarksData([]);
      showAlertMessage("Failed to load data", "error");
    });
};
  const handleAcceptanceChange = (index, value) => {
    const current = remarksStatus[index];

    const updated = { ...remarksStatus, [index]: current === value ? undefined : value, };
    setRemarksStatus(updated);
    const economicItems = criteriaData.filter((item) => item.cs_indicator_type === "Economic");
    const allYes = economicItems.every((_, i) => updated[i] === "yes");
    const allNo = economicItems.every((_, i) => updated[i] === "no");

    if (allYes) setAllAcceptance("yes");
    else if (allNo) setAllAcceptance("no");
    else setAllAcceptance("");
  };
  const validateBeforeForward = () => {
    for (let i = 0; i < criteriaData.length; i++) {
      const item = criteriaData[i];
      if  (item.cs_indicator_type === "Economic" && item.criterion_id != 1) {
        const status = remarksStatus[i];
        if (!status) {
          showAlertMessage(`Please select Required/Not Required for "${item.cs_indicator_name}"`, "error");
          return false;
        }
        if (status === "no" && !remarksText[i]) { showAlertMessage(`Please enter remarks for "${item.cs_indicator_name}"`, "error"); return false; }
      }
    }

    return true;
  };

  const buildPayload = () => {
    return {
      userId: username, districtId: (mainroleid === "5" || mainroleid === "62") ? selecteddistId : district, mandalId: mainroleid === "3" ? mandalid : selectedMandalId, level: "Mandal",
        finYear: formik.values.year,

       indicators: criteriaData.map((item, index) => {
  let isRequired;

  if (item.cs_indicator_type === "Economic" && item.criterion_id != 1) {
    if (remarksStatus[index] === "yes") {
      isRequired = true;
    } else if (remarksStatus[index] === "no") {
      isRequired = false;
    } else {
      isRequired = null;
    }
  } else {
    isRequired = true;
  }

  return {
    csIndicatorId: item.cs_indicator_id,
    isRequired,
    remarks: remarksText[index] || null,
    planningRemarks: planningremarksText[index] || null,
  };
}),

   
    };
  };

  const handleSave = () => {
      if(mainroleid === "5"){
    for (let i = 0; i < criteriaData.length; i++) {
       const item = criteriaData[i];
    if (planningCheckBox[i] && !planningremarksText[i]) {
      showAlertMessage(
        `Please enter Planning Remarks for ${item.cs_indicator_name}`,
        "warning"
      );
      return;
    }
  }
}
    const payload = buildPayload();
    payload.type = "save";

    KpiService.getCriteriaSelectionSave(payload)
      .then((res) => {
        const code = res.data?.SCODE
        const desc = res.data?.SDESC

        if (code === "01") {
          showAlertMessage(desc || "Data Saved Successfully", "success", () => {
            let payload = { "userId": username, "finYear": formik.values.year, "districtId": (mainroleid === "5" || mainroleid === "62") ? selecteddistId.toString() : district.toString(), "mandalId": mainroleid === "3" ? mandalid.toString() : selectedMandalId.toString() }
            fetchCriteriaAndRemarks(payload);
          })
        } else {
          showAlertMessage(desc || "Save failed", "error");
        }
      }).catch(() => {
        showAlertMessage("Something went wrong", "error");
      });
  };


  const handleForward = () => {
    if(mainroleid!=="5"){
    if (!validateBeforeForward()) return;}

    const payload = buildPayload();
    if (mainroleid === "3") {
      payload.type = "forward"
    } else if (mainroleid === "2") {
      payload.type = "approval"
    }


    console.log("Forward Payload:", payload);

    KpiService.getCriteriaSelectionSave(payload)
      .then((res) => {
        const code = res.data?.SCODE
        const desc = res.data?.SDESC
        if (code === "01") {
          showAlertMessage(desc || "Data Forwarded Successfully", "success", () => {
            let payload = { "userId": username, "finYear": formik.values.year, "districtId": district.toString(), "mandalId": mainroleid === "3" ? mandalid.toString() : selectedMandalId.toString() }
            fetchCriteriaAndRemarks(payload);
          })

        } else {
          showAlertMessage(res.data?.SDESC || "Failed to forward", "error");
        }
      })
      .catch(() => {
        showAlertMessage("Something went wrong", "error");
      });

  };


  const handleAllAcceptance = (value) => {
    const updatedStatus = {};

    criteriaData.forEach((item, index) => {
      if (item.cs_indicator_type === "Economic") {
        updatedStatus[index] = value;
      }
    });

    setRemarksStatus(updatedStatus);
    setAllAcceptance(value);
  };

  const handleMandalClick = (mandal) => {
    setSearchMandals("")
    setSelectedMandalId(mandal.mandal_id); setSelectedmandal(mandal.mandal_name);
    setSelecteddistId(mandal.district_id);
    const payload = { userId: username, districtId: mandal.district_id, mandalId: mandal.mandal_id, finYear: formik.values.year, level: "Mandal" };
    fetchCriteriaAndRemarks(payload);
    setShowDetailTable(true);
  };

 
  const MandalData = (id) => {
    setSearchMandals(""); formik.setFieldValue("mandal_id", ""); formik.setFieldValue("year", "");setSelectedmandal(""); setFormikMandalId(""); setShowDetailTable(false); setMandalSummary([]); setCriteriaData([]);
    if (!id) {
      setSelecteddistId(""); setMandalList([]); formik.setFieldValue("district_id", "");
      return;
    }

    setSelecteddistId(id);

    let params = { district_id: id };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        setMandalList([{ id: "0", value: "All" }, ...(res.data ?? [])]);
      }
      else { setMandalList([]) }

    })
  }

  const Planning = (mandalid,year) => {
    setSearchMandals("");
    if (!mandalid||!year) {
      formik.setFieldValue("mandal_id", ""); setSelectedmandal(""); setFormikMandalId(""); setShowDetailTable(false); setMandalSummary([]); setCriteriaData([]);
      return;
    }
    setFormikMandalId(mandalid);
    let payload = { "userId": username, "districtId": selecteddistId, "mandalId": mandalid, finYear: year, level: "Mandal" }
    MandalListTable(payload)

  }


  const filteredMandalsData =
    searchMandals.length > 0 ? mandalSummary?.filter((item) => {
      return (item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(searchMandals.toLowerCase())); })
      );
    }) : mandalSummary;

//     const getMandallevelData=(year)=>{
// if(!year) return;
//  let payload = { "userId": username, "districtId": district.toString(), "mandalId": mandalid.toString(),finYear: year, level: "Mandal" }
//     let payload1 = { "userId": username, "districtId": roleid === "115" ? "0" : district.toString(), "mandalId": "0", level: "Mandal" ,finYear: year}
//     if (["113", "119", "115"].includes(roleid)) { MandalListTable(payload1); }
// if (roleid === "117" || roleid === "111"){fetchCriteriaAndRemarks(payload);}
// // if(roleid==="116"){Planning(formik.values.mandal_id);}

//     }

const getMandallevelData = (year) => {
  if (!year) return;

  // 👉 CLEAR previous data first
  setCriteriaData([]);
  setRemarksData([]);
  setPlanningCheckBox({});
  setStatusCode("");
  setStatusId(null);

  let payload = {
    userId: username,
    districtId: district.toString(),
    mandalId: mandalid.toString(),
    finYear: year,
    level: "Mandal",
  };

  let payload1 = {
    userId: username,
    districtId: roleid === "115" ? "0" : district.toString(),
    mandalId: "0",
    level: "Mandal",
    finYear: year,
  };

  if (["113", "119", "115"].includes(roleid)) {
    MandalListTable(payload1);
  }

  if (roleid === "117" || roleid === "111") {
    fetchCriteriaAndRemarks(payload);
  }
};
  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2>Mandal Performance Indicators Mapping
        <span>Acceptance Entry</span></h2></div></Container>

      <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <Row>
                {["113", "119", "117", "111", "116"].includes(roleid) &&
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>  <label htmlFor="district" className="mb-1 fw-bold"> District </label>
                    <Select
                      {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: !(mainroleid === "5" || mainroleid === "62"), extraOnChange: (option) => { MandalData(option?.id || null) } })}
                    /> </Col>}

                {["117", "111"].includes(roleid) &&
                    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select" >
  {(() => { const departmentValue = roleid === "111" ? deptId : formik.values.department_id; const labelText = ulbdeptlist.includes(departmentValue) ? "ULB" : "Mandal"; return ( <label className="mb-1 fw-bold"> {labelText} </label> ); })()}

                    <Field className="mb-3 form-control" name="mandal_id" type="text" value={selectedmandal} controlId="formBasicEmail"
                      disabled={true} style={{ fontWeight: "bold" }} /> </Col>}

                {["5", "62"].includes(mainroleid) &&
                  <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'>
                     {(() => { const departmentVal= roleid === "111" ? deptId : formik.values.department_id; const labelText = ulbdeptlist.includes(departmentVal) ? "ULB" : "Mandal"; return ( <label className="mb-1 fw-bold"> {labelText} </label> ); })()}
                    <Select className="w-100" isClearable={true} isSearchable={true} name="mandal_id" required={true} getOptionValue={(option) => option.id} getOptionLabel={(option) => option?.value} options={mandalList} value={mandalList?.find((option) => option.id === formik.values?.mandal_id) || null} onChange={(option) => { Planning(option?.id,formik.values.year); formik.setFieldValue("mandal_id", option ? option.id : ""); }}
                      menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }), }}
                    />
                  </Col>}
                 <Col
  xs={12}
  sm={12}
  lg={3}
  md={3}
  xl={3}
  xxl={3}
  className="district-select"
>
  <label htmlFor="year" className="mb-1 fw-bold">Financial Year</label>

  <Select
    {...commonSelectProps({
      name: "year",
      options: yearsList,
      value: formik.values.year,
      optionValueKey: "id",
      optionLabelKey: "value",
      formik,
      extraOnChange: (option) => {
        if (roleid === "116") {
          Planning(
            formik.values.mandal_id || formikMandalId,
            option?.id
          );
        } else {
          getMandallevelData(option?.id);
        }
      },
    })}
  />
</Col>

              </Row> </div> </Form> </FormikProvider>


        {/* ================= SUMMARY TABLE (113,119) ================= */}
        {["113", "119", "115", "116"].includes(roleid) && !showDetailTable && (<>
          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-1" >
              <div className="input-group">
                <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                <input type="text" className="form-control" value={searchMandals} placeholder="Search" onChange={(event) => setSearchMandals(event.target.value)} />
              </div>
            </Col>
          </Row>
          <div id="table-scroll" className="table-scroll"> <div className="table-wrap">

            <Table bordered className="custom-table">
              <thead>
                <tr className="text-center"> <th>Sl.No</th>
                  {formik.values.district_id === "0" &&
                    <th>District</th>}
                  <th>{roleid === "115" ? "District" : "Mandal"}</th>
                  <th>Total Indicators</th> <th>Required</th> <th>Not Required</th> <th>Status</th> </tr>

              </thead>

              <tbody>
                {filteredMandalsData && filteredMandalsData.length > 0 ? (
                  filteredMandalsData?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    {formik.values.district_id === "0" && <td>{item?.district_name}</td>}
                    <td className="text-left">{roleid === "115" ? item.district_name : item.mandal_name} </td> <td className="text-center">{item.total_indicators}</td> <td className="text-center">{item.required_indicators}</td> <td className="text-center">{item.remaining_indicators}</td> <td className="text-center">
                      {item.status_code !== null ? (
                        <button type="button" onClick={() => handleMandalClick(item)} style={{ color: "darkblue", cursor: "pointer", textDecoration: "underline", background: "none", border: "none", padding: 0, }} >
                          {item.status_code}
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>

                  </tr>))
                ) : (
                  <tr>
                    <td colSpan={formik.values.district_id === "0" ? 7 : 6} className="text-center py-3">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          </div>
        </>)}

        {showDetailTable && maintablenb && <>

          <Row>
            {["113", "119", "116"].includes(roleid) && (
              <Col xs="auto" className="ms-auto">
                <Button
                  variant="warning"
                  size="sm"
                  className="btn  mb-2 warn-btn"
                  onClick={() => {

                    MandalListTable({ userId: username, districtId: (mainroleid === "5" || mainroleid === "62") ? formik.values.district_id : district, mandalId: (mainroleid === "5" || mainroleid === "62") ? formikMandalId : mandalid, level: "Mandal",finYear: formik.values.year })
                    setShowDetailTable(false)
                  }}
                >
                  <IoIosReturnLeft style={{ fontSize: "20px" }} /> Back
                </Button>

              </Col>)}
          </Row>
          <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1" >
            <span className="style">  Mandal Performance Indicators Mapping</span>
            {selectedmandal && (<div style={{ fontWeight: "bold", marginTop: "5px" }}> Mandal: {selectedmandal} </div>)}
            {statusCode && ["111", "117"].includes(roleid) && (<div style={{ marginTop: "5px", color: "#2f4f4f", fontWeight: "500" }}> Status: {statusCode} </div>
            )}

          </div>

          <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
            <Table bordered id="my-table" className="custom-table table table-bordered sticky-table">

              <thead>
                <tr className="text-center">
                  <th style={{ headerStyle, width: "100px" }} rowSpan={2}>Sl.No.</th>
                  <th style={{ headerStyle, width: "200px" }} rowSpan={2}>Indicator Type</th>
                  <th style={{ ...headerStyle, width: "200px" }} rowSpan={2}> Indicator </th>
                  <th style={{ headerStyle, width: "300px" }} >Acceptance</th>

                  <th style={headerStyle} rowSpan={2}>Remarks</th>
                  <th style={headerStyle} rowSpan={2}>Planning Remarks</th>
                    {mainroleid === "5" &&<th style={headerStyle} rowSpan={2}>Edit</th>}
                </tr>
                {mainroleid!=="5"&&
                <tr className="text-center">
                  <th>
                    <label className="me-3 text-white">
                      <input
                        type="radio"
                        name="allAcceptance"
                        value="yes"
                        checked={allAcceptance === "yes"}
                        onChange={() => handleAllAcceptance("yes")}
                        disabled={(mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4)}

                      />{" "}
                      All Required
                    </label>

                    <label className="text-white">
                      <input
                        type="radio"
                        name="allAcceptance"
                        value="no"
                        checked={allAcceptance === "no"}
                        disabled={(mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4)}
                        onChange={() => handleAllAcceptance("no")}
                      />{" "}
                      All Not Required
                    </label>
                  </th>
                </tr>
              }              </thead>



              <tbody>

                {criteriaData?.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{index + 1}</td>
                    <td style={{ textAlign: "left" }}>
                      {item.cs_indicator_type}
                    </td>

                    <td style={{ textAlign: "left", width: "350px", maxWidth: "350px", whiteSpace: "normal", wordBreak: "break-word", }} >
                      {item.cs_indicator_name}
                    </td>

                    <td className="text-center">
                      <label className="me-3">
                        <input
                          type="radio"
                          name={`acceptance_${index}`}
                          value="yes"
                          checked={item.cs_indicator_type !== "Economic" || (item.cs_indicator_type === "Economic" && item.criterion_id === 1) ? true : remarksStatus[index] === "yes"}
                          disabled={(item.cs_indicator_type !== "Economic") || (item.cs_indicator_type === "Economic" && item.criterion_id === 1)|| ((mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4)) || (mainroleid === "5" && !planningCheckBox[index])}
                          required={item.is_required}
                          onChange={() => handleAcceptanceChange(index, "yes")}
                        />{" "}
                        Required
                      </label>

                      <label>
                        <input
                          type="radio"
                          name={`acceptance_${index}`}
                          value="no"
                          disabled={(item.cs_indicator_type !== "Economic")|| (item.cs_indicator_type === "Economic" && item.criterion_id === 1)|| ((mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") && statusId !== 4)) || (mainroleid === "5" && !planningCheckBox[index])}
                          checked={remarksStatus[index] === "no"}
                          onChange={() => handleAcceptanceChange(index, "no")}
                        />{" "}
                        Not Required
                      </label>
                    </td>
{/* 
                    <td>
                      {remarksStatus[index] === "no" && item.cs_indicator_type === "Economic" ||(remarksStatus[index] === "yes"&& mainroleid==="5" )&& (
                        <textarea
                          id={`remarks_${index}`}
                          className="form-control"
                          placeholder="Enter remarks"
                          rows={2}
                          title={remarksText[index] || ""}
                          value={remarksText[index] || ""}
                          onChange={(e) =>
                            setRemarksText({
                              ...remarksText,
                              [index]: e.target.value,
                            })

                          }
                          disabled={(mainroleid === "3" && statusId !== 1) || (mainroleid === "2" && statusId !== 2) || ((mainroleid === "5" || mainroleid === "62") )}

                        />
                      )}
                    </td> */}
                    
                    <td>
  {(
    (remarksStatus[index] === "no" &&
      item.cs_indicator_type === "Economic" && item.criterion_id !== 1 ) ||

    (remarksStatus[index] === "yes" &&
      mainroleid === "5" &&
      item.cs_indicator_type === "Economic" && item.criterion_id !== 1 )
  ) && (
    <textarea
      id={`remarks_${index}`}
      className="form-control"
      placeholder="Enter remarks"
      rows={2}
      title={remarksText[index] || ""}
      value={remarksText[index] || ""}
      onChange={(e) =>
        setRemarksText({
          ...remarksText,
          [index]: e.target.value,
        })
      }
      disabled={
        (mainroleid === "3" && statusId !== 1) ||
        (mainroleid === "2" && statusId !== 2) ||
        (mainroleid === "62" || mainroleid==="5")
      }
    />
  )}
</td>
                    <td>
 {/* {mainroleid==="5"&& */}
                      { (item.cs_indicator_type === "Economic" && item.criterion_id !== 1 )&& (

    <textarea
      id={`remarksplanning_${index}`}
      className="form-control"
      placeholder="Enter remarks"
      rows={2}
      title={planningremarksText[index] || ""}
      value={planningremarksText[index] || ""}
      onChange={(e) =>
        setPlanningremarksText({
          ...planningremarksText,
          [index]: e.target.value,
        })
      }
     
      disabled={!(mainroleid === "5" && planningCheckBox[index])}

    />
       )}
</td>

{mainroleid==="5"&& <td className="text-center"> {item.cs_indicator_type === "Economic" && ( <input type="checkbox" className="form-check-input" checked={planningCheckBox[index] || false} onChange={(e) => { const isChecked = e.target.checked; setPlanningCheckBox({ ...planningCheckBox, [index]: isChecked, }); }} /> )} </td>}
                  </tr>
                ))}
              </tbody>

            </Table>

          </div> </div> </>}

        {((mainroleid === "3" && statusId === 1) || (mainroleid === "2" && statusId === 2)) && showDetailTable && (

          <Row className="mt-3">
            <Col className="text-center">
              <div className="bottom-buttons d-flex justify-content-center mb-5">
                <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button> <Button variant="" size="sm" className="next-btn me-4" onClick={handleForward} > {mainroleid === "2" ? "Approve" : "Forward"}<IoReturnDownForward style={{ fontSize: "18px", marginLeft: "5px" }} /> </Button></div> </Col>
          </Row>)}

        {((mainroleid === "5" || mainroleid === "62") && statusId === 4) && showDetailTable && (

          <Row className="mt-3">
            <Col className="text-center">
              <div className="bottom-buttons d-flex justify-content-center mb-5">
                <Button variant="" size="sm" className="save-btn me-4" onClick={handleSave} > Save <FaRegSave className="ms-1 s-icon" /> </Button>
                
                </div> </Col>
          </Row>)}

      </Container>

      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
